function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM19 34.96C10.1855 34.96 3.04 27.8145 3.04 19C3.04 10.1855 10.1855 3.04 19 3.04C27.8145 3.04 34.96 10.1855 34.96 19C34.96 27.8145 27.8145 34.96 19 34.96ZM27.3968 11.9153C28.0838 11.2282 29.1977 11.2282 29.8847 11.9153H29.8847C30.5718 12.6024 30.5718 13.7165 29.8847 14.4036L17.445 26.8448C16.7769 27.5129 15.7054 27.5312 15.015 26.8998C14.9962 26.8828 14.9769 26.8646 14.9571 26.8448L8.11527 20.0021C7.42823 19.315 7.42826 18.201 8.11527 17.5139C8.80228 16.8268 9.91617 16.8268 10.6032 17.5139L16.2011 23.1124L27.3968 11.9153Z",
  fill: "currentColor"
});

const SvgClusterCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 38 38",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClusterCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cluster-check.c6d20fd7.svg";
export { ForwardRef as ReactComponent };